var _createForOfIteratorHelper = require("/home/runner/work/my.phone.com/my.phone.com/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/createForOfIteratorHelper");
var _classCallCheck = require("/home/runner/work/my.phone.com/my.phone.com/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/classCallCheck");
var _createClass = require("/home/runner/work/my.phone.com/my.phone.com/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/createClass");
var _inherits = require("/home/runner/work/my.phone.com/my.phone.com/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/inherits");
var _createSuper = require("/home/runner/work/my.phone.com/my.phone.com/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/createSuper");
var _require = require('orange-colors'),
  OrangeColor = _require.OrangeColor;
var _require2 = require('orange-svg'),
  OrangeSVGLine = _require2.OrangeSVGLine,
  OrangeSVGCircle = _require2.OrangeSVGCircle,
  OrangeSVGText = _require2.OrangeSVGText;
var OrangeChartAbstract = require('./orange-chart-abstract');
var OrangeSVGCircularSector = require('./orange-svg-circular-sector');
var OrangeChartPie = /*#__PURE__*/function (_OrangeChartAbstract) {
  "use strict";

  _inherits(OrangeChartPie, _OrangeChartAbstract);
  var _super = _createSuper(OrangeChartPie);
  function OrangeChartPie() {
    _classCallCheck(this, OrangeChartPie);
    return _super.apply(this, arguments);
  }
  _createClass(OrangeChartPie, [{
    key: "next_color",
    get:
    /**
     * Next default color to be used for chart's sector (72 different colors are supported)
     *
     * @type {string}
     */
    function get() {
      if (!this._color) {
        this._color = new OrangeColor('e50000');
      } else {
        this._color.h += 85;
      }
      return "#".concat(this._color.hex_string);
    }

    /**
     * Basic dimensions of the chart
     *
     * @param {object} view
     * @return {{width:number, height:number}}
     * @protected
     */
  }, {
    key: "_get_basic_dimensions",
    value: function _get_basic_dimensions(view) {
      var diameter = view.hasOwnProperty('diameter') ? view.diameter : 100;
      var width = view.hasOwnProperty('width') ? view.width : view.hasOwnProperty('label') && view.label !== false ? 2 * diameter : diameter;
      var height = view.hasOwnProperty('height') ? view.height : diameter;
      return {
        width: width,
        height: height
      };
    }

    /**
     * Label lines color
     *
     * @type {string}
     */
  }, {
    key: "_do_render",
    value:
    /**
     * Renders chart
     *
     * @param {OrangeSVG} svg
     * @param {object} view
     * @param {number} x1
     * @param {number} y1
     * @param {number} x2
     * @param {number} y2
     * @protected
     */
    function _do_render(svg, view, x1, y1, x2, y2) {
      var _this = this;
      var width = x2 - x1;
      var height = y2 - y1;
      var diameter = view.hasOwnProperty('diameter') ? view.diameter : Math.min(width, height);
      var radius = diameter / 2;
      var default_margin = view.hasOwnProperty('default_margin') ? view.default_margin : 10;
      var label_line_color = view.hasOwnProperty('label_line_color') ? view.label_line_color : this.constructor.COLOR;
      var total, colors, value, rendering_value, shown, cc, is_right, l;
      var _loop = function _loop() {
        var pie = _Object$values[_i];
        // TODO Real support of multiple charts
        shown = 0;
        colors = pie.hasOwnProperty('color') ? pie.color : {};
        total = _this._data.map(function (v) {
          return v[pie.property];
        }).reduce(function (a, c) {
          return a + c;
        }, 0);
        var callbacks = _this.getCallbacks(pie.property);
        var _iterator = _createForOfIteratorHelper(_this._data),
          _step;
        try {
          for (_iterator.s(); !(_step = _iterator.n()).done;) {
            var row = _step.value;
            var color = colors && colors.property && colors.mapping && colors.mapping.hasOwnProperty(row[colors.property]) ? colors.mapping[row[colors.property]] : _this.next_color;
            value = row[pie.property];
            rendering_value = view.fair ? value : Math.min(value + 0.01 * total, total - shown);
            var callback_data = {
              value: value,
              'property': pie.property,
              'label': row[colors.property]
            };
            var sector = total === rendering_value ? new OrangeSVGCircle(x1 + width / 2, y1 + height / 2, radius, color) : new OrangeSVGCircularSector(shown / total, rendering_value / total, radius, color, x1 + width / 2, y1 + height / 2);
            sector.args = {
              'data-property': row[colors.property],
              'class': 'orange-chart-pie-slice'
            };
            svg.appendChild(sector, callbacks, callback_data);
            if (view.hasOwnProperty('label') && view.label !== false && (view.label === true || value / total * 100 > view.label)) {
              cc = OrangeSVGCircularSector.calculateCoordinates((shown + value / 2) / total, radius);
              is_right = cc[0] < 0;
              l = {
                'x1': x1 + width / 2,
                'y': cc[1] + y1 + height / 2
              };
              l.x2 = is_right ? l.x1 - radius - 2 * default_margin : l.x1 + radius + 2 * default_margin;
              l.x1 = is_right ? l.x1 + cc[0] : l.x1 + cc[0];
              var line = new OrangeSVGLine(l.x1, l.y, l.x2, l.y, label_line_color, null);
              line.args = {
                'class': "orange-chart-scale orange-chart-pie-line"
              };
              svg.appendChild(line);
              var text = new OrangeSVGText(row[colors.property], is_right ? l.x2 - default_margin : l.x2 + default_margin, l.y + default_margin * 0.55, is_right ? 'end' : 'start');
              text.args = {
                'class': 'orange-chart-label'
              };
              svg.appendChild(text);
            }
            shown += value;
          }
        } catch (err) {
          _iterator.e(err);
        } finally {
          _iterator.f();
        }
      };
      for (var _i = 0, _Object$values = Object.values(this._source_mapping); _i < _Object$values.length; _i++) {
        _loop();
      }
    }
  }], [{
    key: "chart_type_code",
    get:
    /**
     * Chart type
     *
     * @type {string}
     * @static
     */
    function get() {
      return 'pie';
    }

    /**
     * Returns allowed axes for the chart
     *
     * @type {string[]}
     * @static
     */
  }, {
    key: "allowed_axes",
    get: function get() {
      return [];
    }
  }, {
    key: "COLOR",
    get: function get() {
      return this._color || 'rgba(127,127,127,0.2)';
    }

    /**
     * Label lines color
     *
     * @type {string}
     */,
    set: function set(value) {
      this._color = value;
    }
  }]);
  return OrangeChartPie;
}(OrangeChartAbstract);
module.exports = OrangeChartPie;